import React, { useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";

import config from '../config.json'

import { isMobileOnly } from 'react-device-detect';
import { avisoConfirmacion, createAvisoVisorEsActual, destroyAvisoVisorEsActual } from '../configvisores/domElements';
import { destroyElement } from '../utils/domUtils';

function NavegacionSecciones({ visible, seccionesNavegar, numSeccionesMax, urlBaseIconos, extensionIconos, parametrosVisor, codigoWebMapIdUrlEmbebida, mostrarMenuNoVisorBase }) {

    const navigate = useNavigate();

    let { codigoSeccion, tiponav } = useParams();

    const esNavSecc = (tiponav === config.tipoNavegacionSoloSeccionIni || tiponav === config.tipoNavegacionSoloSeccion)
    const seccionNavegarAsoCodigoSeccion = seccionesNavegar.find(x => x.codigo === codigoSeccion)
    const seccionActivaInicial = tiponav === config.tipoNavegacionSoloSeccionIni ? seccionNavegarAsoCodigoSeccion : null;

    const [panelVisible, setPanelVisible] = useState(tiponav === config.tipoNavegacionSoloSeccion ? false : true);
    const [seccionActiva, setSeccionActiva] = useState(seccionActivaInicial);
    const [arrIndicesSeccionesVisibles, setArrIndicesSeccionesVisibles] = useState(Array.from(Array(Math.min(numSeccionesMax, seccionesNavegar.length)).keys()));

    function validarActiva(arr){
        const indiceSeccionActiva = seccionesNavegar.findIndex(x => x.codigo === seccionActiva?.codigo);
        if (!arr.includes(indiceSeccionActiva) && seccionActiva){
            activarDesactivarSeccion(seccionActiva);
        }
    }

    function moverIzq(){
        const auxArr = arrIndicesSeccionesVisibles.map(x => x - 1);
        validarActiva(auxArr);
        setArrIndicesSeccionesVisibles(auxArr);
    }

    function moverDer(){
        const auxArr = arrIndicesSeccionesVisibles.map(x => x + 1);
        validarActiva(auxArr);
        setArrIndicesSeccionesVisibles(auxArr);
    }

    function activarDesactivarSeccion(seccion){
        destroyElement(config.domIds.avisoConfirmacion);
        if (seccion.codigo === seccionActiva?.codigo){
            setSeccionActiva(null)
        } else {
            setSeccionActiva(seccion)
        }
    }

    function seleccionVisor(codigoSeccion, codigoVisor, institucional, webMapId, nombre, nombreSeccion, esInicio){
        destroyElement(config.domIds.avisoConfirmacion);
        if (esInicio && mostrarMenuNoVisorBase){
            navigate(`/${config.identificadorHome}`)
        } else if (codigoSeccion === parametrosVisor.codigoSeccion && codigoVisor === parametrosVisor.codigoVisor){
            if (webMapId === codigoWebMapIdUrlEmbebida){
                // avisoConfirmacion("¿Deseas recargar el visor?", cambiarWebMap, [codigoSeccion, codigoVisor]); //No recarga el visor embebido
                avisoConfirmacion("¿Deseas recargar el visor actual?", reloadPage);
            } else {
                createAvisoVisorEsActual()
                // setSeccionActiva(null);
            }
        } else {
            if (institucional){
                avisoConfirmacion(`Vas a dirigirte a un visor institucional (${nombreSeccion} - ${nombre}), será necesario autenticarse, ¿deseas continuar?`, cambiarWebMap, [codigoSeccion, codigoVisor]);
            } else {
                cambiarWebMap(codigoSeccion, codigoVisor);
            }
        }
    }

    function reloadPage(){
        navigate(0)
    }

    function cambiarWebMap(codigoSeccion, codigoVisor){
        destroyAvisoVisorEsActual();
        if (tiponav === config.tipoNavegacionSinIni) {
            navigate(`/${codigoSeccion}/${codigoVisor}/${config.tipoRutaNavegarGeneral}/${config.tipoNavegacionSinIni}`);
        } else {
            navigate(`/${codigoSeccion}/${codigoVisor}/${config.tipoRutaNavegarGeneral}${esNavSecc ? "/" + config.tipoNavegacionSoloSeccion : ""}`);
        }
    }

    function cambiarVisibilidadPanel(){
        destroyElement(config.domIds.avisoConfirmacion);
        if (esNavSecc){
            activarDesactivarSeccion(seccionNavegarAsoCodigoSeccion)
        }
        setPanelVisible(!panelVisible);
    }
    
    if (!seccionesNavegar){
        return null;
    }

    let altoIcono = 32;
    let fontSizeTitulo = "large";
    let marginIcono = "6px";
    let paddingFlechaLR = "6px";
    if (isMobileOnly){
        altoIcono = 32; //Con opción de diferenciar alto en versión móvil
        fontSizeTitulo = "medium";
        marginIcono = "8px";
        paddingFlechaLR = "8px"
    }

    const flechaIzqActiva = arrIndicesSeccionesVisibles[0] > 0;
    const flechaDerActiva = arrIndicesSeccionesVisibles[arrIndicesSeccionesVisibles.length - 1] < seccionesNavegar.length - 1;

    const estiloFlechaBase = { display: numSeccionesMax < seccionesNavegar.length ? "block" : "none", padding: paddingFlechaLR };
    const estiloFlechaIzq = {...estiloFlechaBase, color: flechaIzqActiva ? "black" : "#bfbfbf", cursor: flechaIzqActiva ? "pointer" : "inherit" };
    const estiloFlechaDer = {...estiloFlechaBase, color: flechaDerActiva ? "black" : "#bfbfbf", cursor: flechaDerActiva ? "pointer" : "inherit" };

    const indexPrimerVisorInstit = seccionActiva?.visores.findIndex(x => x.institucional === 1);

    return (
        <div className='panelNavegacionSeccionesParent' style={{bottom: parametrosVisor.webMapId === codigoWebMapIdUrlEmbebida ? "0px" : "16px"}}>
            <i 
                className={`panelNavegacionSeccionesFlecha iconoLink fa fa-chevron-${panelVisible ? "down" : "up"}`}
                aria-hidden="true"
                style={{ fontSize: isMobileOnly ? "small" : "medium", backgroundColor: "white" }}
                title={panelVisible ? "Ocultar" : "Mostrar navegación entre secciones"}
                onClick={() => cambiarVisibilidadPanel()}
            />
            <div className="panelNavegacionSecciones" style={{ display: visible ? (panelVisible ? "block" : "none") : "none" }}>
                <div style={{ marginLeft: "2px", marginRight: "2px" }}>
                    {
                        !seccionActiva ? 
                        null :
                        <React.Fragment>
                            {
                                esNavSecc || seccionActiva.esDeVisorInicio ?
                                null :
                                <div className="panelNavegacionSeccionesTitulo" style={{ fontSize: fontSizeTitulo }}>
                                    <span>{ seccionActiva.nombre }</span>
                                    <span title="Contraer" style={{marginLeft: "5px"}} onClick={() => setSeccionActiva(null)}>
                                        <i className="iconoLink fa fa-arrow-circle-down" aria-hidden="true"></i>
                                    </span>
                                </div>
                            }
                            {
                                seccionActiva.visores.map((visor, indexVisor) => 
                                    <React.Fragment key={`${visor.codigoSeccion}_${visor.codigoVisor}_frag`}>
                                        {
                                            !visor.esInicio && (indexVisor === 0 || indexVisor === indexPrimerVisorInstit) ?
                                            (
                                                <div style={{paddingTop: indexVisor === 0 ? (esNavSecc ? "7px" : "4px") : "12px"}}>
                                                    {`Visores ${indexVisor === 0 ? "públicos" : "institucionales"}:`}
                                                </div>
                                            ): null
                                        }
                                        <div key={`${visor.codigoSeccion}_${visor.codigoVisor}`} style={{paddingTop: seccionActiva.esDeVisorInicio ? "10px" : "5px", marginLeft: "10px", marginRight: "10px"}}>
                                            <button className='esri-button' title={visor.codigoSeccion === parametrosVisor.codigoSeccion && visor.codigoVisor === parametrosVisor.codigoVisor ? "Visor actual" : (visor.esInicio ? "" : "Ir a") } onClick={() => seleccionVisor(visor.codigoSeccion, visor.codigoVisor, visor.institucional, visor.webMapId, visor.nombre, visor.nombreSeccion, visor.esInicio)}>
                                                { visor.esInicio ? `${mostrarMenuNoVisorBase ? "Volver al menú" : "Ir al visor"} de inicio` : visor.nombre }
                                            </button>
                                        </div>
                                    </React.Fragment>
                                )
                            }
                        </React.Fragment>
                    }
                    {
                        esNavSecc ?
                        <div style={{ marginBottom: "10px"}}/>
                        :
                        <div style={{ marginBottom: "3px", marginTop: seccionActiva ? "17px" : "7px", display: "flex", alignItems: "center", justifyContent: "space-around" }}>
                            <span onClick={flechaIzqActiva ? moverIzq : undefined} style={estiloFlechaIzq}>
                                <i className="fa fa-chevron-left" aria-hidden="true"></i>
                            </span>
                        {
                            arrIndicesSeccionesVisibles.map(indiceVisible => {
                                const seccion = seccionesNavegar[indiceVisible];
                                const seccionEstaActiva = seccion.codigo === seccionActiva?.codigo;
                                const urlBaseStd = urlBaseIconos.endsWith("/") ? urlBaseIconos : `${urlBaseIconos}/`; //Agrega slash final si no lo tiene
                                const urlImagen = `${urlBaseStd}${seccion.codigo}${codigoSeccion === seccion.codigo ? config.iconosSecciones.sufijosNombres.active : ""}.${extensionIconos}`;
                                return(
                                    <div key={seccion.codigo} className='tooltip' onClick={() => activarDesactivarSeccion(seccion)}>
                                        <img                                     
                                            key={seccion.codigo}
                                            height={altoIcono}
                                            style={{ marginLeft: marginIcono, marginRight: marginIcono, position: "relative", transition: "top 0.5s ease 0s", top: seccionEstaActiva ? "-10px" : "0px" }}
                                            src={urlImagen}
                                            alt={seccion.codigo}
                                            title={seccionEstaActiva ? "Contraer" : ""}
                                        />
                                        {
                                            seccionEstaActiva || isMobileOnly ?
                                            null :
                                            <span className='tooltiptext'>
                                                {seccion.nombre}
                                            </span>
                                        }
                                    </div>
                                    )
                                })

                            }
                            <span onClick={flechaDerActiva ? moverDer : undefined} style={estiloFlechaDer}>
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                            </span>
                        </div>
                    }
                </div>
                <div style={{ paddingLeft: "10px", paddingRight: "10px", paddingTop: "0px", paddingBottom: "2px", fontSize: "smaller" }}>
                    {"Estás en"} <span style={{color: "#0a698f"}}>{seccionNavegarAsoCodigoSeccion.nombre}</span> 
                </div>
            </div>
        </div>
    );
}

export default NavegacionSecciones;